import type { BadgeProps } from '@mui/material';
import type { FC, HTMLProps } from 'react';
import { NotifBadge } from './styles';

type Props = {
  count?: number;
  sx?: BadgeProps['sx'];
} & Omit<HTMLProps<HTMLSpanElement>, 'as'>;

export const NotifBadgeIcon: FC<Props> = ({ count, ...attrs }) => (
  <NotifBadge {...attrs}>{count || '1'}</NotifBadge>
);
